import { PlacementData } from "../tutor-reports/tutorreport";
import { StudentBookingStudentDetails } from "./student-booking-student-details";
import { PlacementMaintenance } from "../maintenance/placement-maintenance.model";
import { SelectedSessionDate } from "./selected-session-date.model";
import { TimelineSectionStatus } from "../timeline-models/timeline-section-status.enum";

export class StudentBooking {
  studentDetails: StudentBookingStudentDetails[];
  lessonSummary: string;
  clientId: number;
  placementId: number;
  startDate: Date;
  startTime: any;
  endTime: any;
  lockTime: boolean;
  lockSubject: boolean;
  subject: string;
  status: string;
  sessionId: number;
  tutorId: number;
  lessonType: string;

  constructor(placementMaintenance: PlacementMaintenance, selectedSessionDate: SelectedSessionDate, placementData: PlacementData) {

    this.sessionId = 0;
    this.clientId = placementMaintenance.placementInfo.clientId;
    this.placementId = +placementMaintenance.placementInfo.placementId;
    this.studentDetails = [];
    
    if (placementMaintenance.placementStudents && placementMaintenance.placementStudents.length > 0) {
      placementMaintenance.placementStudents.forEach(student => {
        const resultStudent = new StudentBookingStudentDetails(student);
        this.studentDetails.push(resultStudent);
      });
    }
    
    this.startDate = selectedSessionDate.startDate;
    this.startTime = selectedSessionDate.startTime;
    this.endTime = selectedSessionDate.endTime;
    this.status = TimelineSectionStatus.New;
    this.lockSubject = placementMaintenance.placementInfo.lockSubject;
    this.lockTime = placementData.lockTime;
    this.subject = placementMaintenance.placementInfo.subject;
    this.tutorId = placementData.tutorId;
    this.lessonType = placementMaintenance.placementInfo.lessonPlanTypeCode;
  }
}
